<template>
  <v-layout row wrap mx-4 my-2>
    <v-flex xs12 md8 wrap>
      <v-layout column main-section>
        <v-flex pt-3>
          <!-- <v-card-title>
              <h3 class="halfwhite-text">View all of Your Ovations</h3>
              <h3 class="section-title halfwhite-text text-uppercase">
                Activity Dashboard
              </h3>
            </v-card-title> -->
          <div class="mb-4">
            <SendOvationsCard></SendOvationsCard>
          </div>
          <v-card color="transparent" flat class="rounded">
            <v-card-title>
              <v-icon>mdi-view-dashboard-outline</v-icon>
              <h4 class="headline halfwhite-text ml-2">Activity Dashboard</h4>
              <!-- <v-flex ml-2>
                <v-btn icon @click.stop="loadActivities()" :disabled="loading">
                  <v-icon title="Refresh" color="secondary">mdi-refresh</v-icon>
                </v-btn>
              </v-flex> -->
              <v-spacer></v-spacer>
              <v-flex style="flex-grow: 0" v-if="showFilter">
                <v-select
                  height="25"
                  class="width-max-120px"
                  dense
                  outline
                  single-line
                  :items="yearList"
                  v-model="selectedYear"
                  label="Year"
                  @change="changeYear"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex ml-2 style="flex-grow: 0" v-if="showFilter">
                <v-select
                  height="25"
                  class="width-max-120px"
                  dense
                  outline
                  single-line
                  :items="monthList"
                  v-model="selectedMonth"
                  label="Month"
                  @change="changeMonth"
                  hide-details
                ></v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex mr-4 style="flex-grow: 0">
                <div
                  class="d-flex align-center filter-container"
                  @click.stop="showFilter = !showFilter"
                >
                  <div>
                    <v-icon color="#d13b55" size="20">mdi-tune</v-icon>
                  </div>
                  <div class="text-main-theme ml-1">Filter</div>
                </div>
              </v-flex>
              <v-flex mr-3 style="flex-grow: 0">
                <div>
                  <v-switch
                    color="red darken-2"
                    v-model="showUserActivity"
                    label="Your Activity"
                    @change="toggleUserActivity"
                    :disabled="loading"
                    hide-details
                  ></v-switch>
                </div>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-flex v-if="loading">
                <v-card color="white" class="rounded" elevation="0">
                  <v-card-text>
                    <div>
                      <v-progress-linear
                        color="#d13b55"
                        height="2"
                        :indeterminate="true"
                      ></v-progress-linear>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex v-if="!loading && activities.length == 0">
                <v-card color="white" class="rounded" elevation="0">
                  <v-card-text>
                    <div>No data to show</div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <div v-for="(activityItem, index) in activities" :key="index">
                <v-flex v-if="!loading" mb-3>
                  <v-card
                    color="white"
                    class="light-shadow rounded"
                    elevation="0"
                  >
                    <v-flex>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex style="flex-grow: 0">
                            <v-chip
                              outline
                              class="font-weight-black"
                              :text-color="getActivityColor(activityItem)"
                              :title="
                                'Sender: ' +
                                activityItem.sourceUser.firstname +
                                ' ' +
                                activityItem.sourceUser.lastname
                              "
                            >
                              <v-avatar :color="getActivityColor(activityItem)">
                                <img
                                  class="user-avatar-padding"
                                  v-if="
                                    (activityItem.sourceUser || {})
                                      .isavatarlocal
                                  "
                                  :src="
                                    (activityItem.sourceUser || {}).avatarlocal
                                  "
                                />
                                <span v-else class="white--text">{{
                                  activityItem.sourceUser.firstname
                                    .charAt(0)
                                    .toUpperCase() +
                                  activityItem.sourceUser.lastname
                                    .charAt(0)
                                    .toUpperCase()
                                }}</span>
                              </v-avatar>
                              <!-- <v-icon>mdi-coins</v-icon> -->
                              <img
                                class="mr-2"
                                src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/favicon-32x32.png"
                                alt="Ovation"
                                style="width: 18px"
                              />
                              <span class="subheading font-weight-bold"
                                >-{{ toggleAmount(activityItem) }}</span
                              >
                            </v-chip>
                          </v-flex>
                          <v-flex style="flex-grow: 0">
                            <div class="mt-2">
                              <v-icon color="secondary"
                                >arrow_forward_ios</v-icon
                              >
                            </div>
                          </v-flex>
                          <v-flex style="flex-grow: 0">
                            <v-chip
                              outline
                              class="font-weight-black"
                              text-color="#e0922f"
                              :title="
                                'Receiver: ' +
                                activityItem.targetUser.firstname +
                                ' ' +
                                activityItem.targetUser.lastname
                              "
                            >
                              <v-avatar color="#e0922f">
                                <img
                                  class="user-avatar-padding"
                                  v-if="
                                    (activityItem.targetUser || {})
                                      .isavatarlocal
                                  "
                                  :src="
                                    (activityItem.targetUser || {}).avatarlocal
                                  "
                                />
                                <span v-else class="white--text">{{
                                  activityItem.targetUser.firstname
                                    .charAt(0)
                                    .toUpperCase() +
                                  activityItem.targetUser.lastname
                                    .charAt(0)
                                    .toUpperCase()
                                }}</span>
                              </v-avatar>
                              <!-- <v-icon>mdi-coins</v-icon> -->
                              <img
                                class="mr-2"
                                src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/favicon-32x32.png"
                                alt="Ovation"
                                style="width: 18px"
                              />
                              <span class="subheading font-weight-bold"
                                >+{{ toggleAmount(activityItem) }}</span
                              >
                            </v-chip>
                          </v-flex>
                          <v-flex text-xs-right>
                            <span class="font-weight-light caption">{{
                              activityItem.date
                                | moment("dddd, MMMM DD, YYYY, h:mm a")
                            }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-2 ml-2>
                          <v-flex>
                            <div class="font-weight-medium">
                              {{ activityItem.message }}
                              <span
                                class="ml-2"
                                v-html="getActivityIcon(activityItem)"
                              ></span>
                            </div>
                            <div class="body-1 mt-2 grey--text">
                              <div
                                v-html="activityItem.description"
                                class="dashboard-media-preview"
                              ></div>
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-1 ml-0>
                          <v-flex>
                            <v-card
                              elevation="0"
                              color="white"
                              class="rounded-20"
                            >
                              <div class="d-inline-flex dashboard-likes">
                                <div>
                                  <v-btn
                                    flat
                                    icon
                                    :color="getLikeButtonColor(activityItem)"
                                    @click.stop="toggleUserLike(activityItem)"
                                    :disabled="likeLoading"
                                  >
                                    <v-icon>mdi-thumb-up-outline</v-icon>
                                  </v-btn>
                                </div>
                                <!-- <div
                                  v-if="
                                    activityItem.likes &&
                                    activityItem.likes.length > 0
                                  "
                                  class="ml-2 heading"
                                >
                                  {{ activityItem.likes.length }}
                                </div> -->
                                <div
                                  v-for="(
                                    userLike, likeIndex
                                  ) in activityItem.likes"
                                  :key="likeIndex"
                                >
                                  <v-avatar
                                    color="primary lighten-1"
                                    size="24"
                                    :class="{
                                      'like-avatar-ml': likeIndex > 0,
                                    }"
                                    :title="userLike.fullname"
                                  >
                                    <img
                                      v-if="userLike.image"
                                      :src="userLike.image"
                                      :alt="userLike.fullname"
                                    />
                                    <span
                                      v-else
                                      :class="{
                                        'white--text': true,
                                        caption: true,
                                      }"
                                      >{{
                                        getUserInitialsFromName(
                                          userLike.fullname
                                        )
                                      }}</span
                                    >
                                  </v-avatar>
                                  <!-- <v-icon
                                      :class="{
                                        'like-avatar': true,
                                        'like-avatar-ml': likeIndex > 0,
                                      }"
                                      size="30"
                                      v-else
                                      :title="userLike.fullname"
                                      >account_circle</v-icon> -->
                                  <!-- <v-chip
                                    color="blue"
                                    text-color="black"
                                    small
                                    outline
                                    v-for="(
                                      userLike, likeIndex
                                    ) in activityItem.likes"
                                    :key="likeIndex"
                                  >
                                    <v-avatar>
                                      <img
                                        v-if="userLike.image"
                                        :src="userLike.image"
                                        :alt="userLike.fullname"
                                        :title="userLike.fullname"
                                      />
                                      <v-icon v-else :title="userLike.fullname"
                                        >account_circle</v-icon
                                      >
                                    </v-avatar>
                                    <span class="caption">{{
                                      userLike.fullname +
                                      ($store.getters.getUserIdentifier ===
                                      userLike.userId
                                        ? " (You)"
                                        : "")
                                    }}</span>
                                  </v-chip> -->
                                </div>
                              </div>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-flex>
                  </v-card>
                </v-flex>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex></v-flex>
    <v-flex xs12 md3 px-3>
      <v-layout column wrap>
        <DashboardSidebar></DashboardSidebar>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import DashboardSidebar from "@/components/DashboardSidebar";
import SendOvationsCard from "@/components/SendOvationsCard";

export default {
  name: "dashboard",
  components: { DashboardSidebar, SendOvationsCard },
  data() {
    return {
      loading: true,
      likeLoading: false,
      showFilter: false,
      activities: [],
      allActivities: [],
      userActivities: [],
      showUserActivity: false,
      yearList: [
        (new Date().getFullYear() - 1).toString(),
        new Date().getFullYear().toString(),
      ],
      selectedYear: new Date().getFullYear().toString(),
      monthList: [
        { text: "Jan", value: "1" },
        { text: "Feb", value: "2" },
        { text: "Mar", value: "3" },
        { text: "Apr", value: "4" },
        { text: "May", value: "5" },
        { text: "Jun", value: "6" },
        { text: "Jul", value: "7" },
        { text: "Aug", value: "8" },
        { text: "Sep", value: "9" },
        { text: "Oct", value: "10" },
        { text: "Nov", value: "11" },
        { text: "Dec", value: "12" },
      ],
      selectedMonth: (new Date().getMonth() + 1).toString(),
    };
  },
  computed: {},
  methods: {
    loadActivities: function () {
      this.loading = true;
      this.activities = [];
      this.allActivities = [];
      this.userActivities = [];
      axios
        .get(
          "/api/fund/spendovationlist/" +
            this.selectedYear +
            "/" +
            this.selectedMonth,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.loading = false;
          this.activities = response.data;
          this.allActivities = this.activities;
          this.toggleUserActivity();
        })
        .catch((e) => {
          this.loading = false;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Recent Activity.<br>Response: " +
              e.response.data.message +
              "<br>Error #NDI832",
            messageType: "error",
          });
        });
    },
    getActivityIcon: function (activity) {
      if (activity && activity.message) {
        // birth-day
        if (activity.message.includes("Birthday")) {
          //return "mdi-cake-layered mdi-18px";
          return "&#127874;";
        } else if (activity.message.includes("Anniversary")) {
          //return "mdi-balloon";
          return "&#127881;";
        } else if (activity.message.includes("Shared")) {
          //return "mdi-share mdi-18px";
          return "&#129309;";
        }
        //return "mdi-emoticon-excited mdi-18px";
        return "&#129395;";
      }
    },
    getActivityColor: function (activity) {
      if (activity && activity.message) {
        if (activity.message.includes("Shared")) {
          return "#e0922f";
        }
        return "#3cc0c9";
      }
    },
    toggleUserActivity() {
      if (this.showUserActivity) {
        if (this.userActivities.length == 0) {
          // Filter user activity and cache it
          var that = this;
          this.userActivities = this.allActivities.filter(function (item) {
            if (item && item.sourceUser && item.targetUser) {
              return (
                item.sourceUser.nameidentifier ===
                  that.$store.getters.getUserIdentifier ||
                item.targetUser.nameidentifier ===
                  that.$store.getters.getUserIdentifier
              );
            }
          });
        }
        this.activities = this.userActivities;
      } else {
        this.activities = this.allActivities;
      }
    },
    toggleAmount(activity) {
      if (!(activity.transaction || {}).isPrivate)
        return (activity.transaction || {}).amount;
      else {
        if (
          activity.sourceUser.nameidentifier ===
            this.$store.getters.getUserIdentifier ||
          activity.targetUser.nameidentifier ===
            this.$store.getters.getUserIdentifier
        )
          return (activity.transaction || {}).amount;
        else return "";
      }
    },
    changeYear: function () {
      this.loadActivities();
    },
    changeMonth: function () {
      this.loadActivities();
    },
    getLikeButtonColor: function (activity) {
      var that = this;
      if (activity && activity.likes && activity.likes.length > 0) {
        var currentUserLike = activity.likes.filter(function (like) {
          return like.userId === that.$store.getters.getUserIdentifier;
        });
        if (currentUserLike && currentUserLike.length > 0) {
          return "blue lighten-2";
        }
      }
      return "grey lighten-1";
    },
    toggleUserLike: function (activity) {
      this.likeLoading = true;

      const params = {
        orgId: activity.subdomain,
        sortKey: activity.sortkey,
        likeModel: {
          userId: this.$store.getters.getUserIdentifier,
          fullname:
            this.$store.state.userSelf.profile.firstname +
            " " +
            this.$store.state.userSelf.profile.lastname,
          image: this.$store.getters.getProfileImageUrl,
        },
      };

      axios
        .post("/api/user/like", params, this.$store.state.axiosConfig)
        .then((res) => {
          this.likeLoading = false;
          activity.likes = res.data;
        })
        .catch((err) => {
          this.likeLoading = false;
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", err);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error: Toogle Like.<br><strong>" +
              err.response.data.message +
              "</strong>",
            messageType: "error",
          });
        });
    },
    getUserInitialsFromName: function (fullname) {
      if (fullname) {
        var nameArray = fullname.split(" ");
        if (nameArray && nameArray.length > 1) {
          var fn = nameArray[0];
          var ln = nameArray[1];
          return fn.charAt(0).toUpperCase() + ln.charAt(0).toUpperCase();
        } else if (nameArray && nameArray.length > 0) {
          var fn = nameArray[0];
          if (fn.length > 2)
            return fn.charAt(0).toUpperCase() + fn.charAt(1).toUpperCase();
          else return fn.charAt(0).toUpperCase();
        }
      }
      return "";
    },
  },
  beforeMount() {
    this.loadActivities();
  },
};
</script>

<style scoped>
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #212121 !important;
}
.theme--light .theme--light.v-btn {
  padding: 0 !important;
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>